import React from 'react';

import { EditableComponent } from '@adobe/aem-react-editable-components';
import { StyledModalPageContent } from './ModalPageContent.styles';
import { ModalPageContentProps } from './ModalPageContent.types';
import { LegalTextWithLink } from '../../molecules/LegalTextWithLink';

export const ModalPageContentConfig = {
  emptyLabel: 'ModalPageContent',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/legalmodal`,
};

export const ModalPageContent = (props: ModalPageContentProps) => {
  return (
    <EditableComponent config={ModalPageContentConfig} {...props}>
      <ModalPageContentComp {...props} />
    </EditableComponent>
  );
};

const ModalPageContentComp: React.FC<ModalPageContentProps> = ({ title, content }) => {
  return (
    <StyledModalPageContent data-testid="legal-ModalPageContent" data-component-name="o-legal-ModalPageContent">
      <div className="js-modal m-modal">
        <div className="js-modal-header m-modal-header">
          <h4 className="mb-0">{title}</h4>
        </div>
        <div className="js-modal-body m-modal-body">
          <div className="js-modal-content m-modal-content">
            <LegalTextWithLink descriptionText={content} testId="richtext-modal-content" />
          </div>
        </div>
      </div>
    </StyledModalPageContent>
  );
};
